import type { HttpClient } from '@remodeling/base';
import {
  GetGoodsDetailRequest,
  GetGoodsDetailResponse,
} from '../../model/dto/goods';

export class GetGoodsDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsDetailRequest) {
    return await this.httpClient.request<GetGoodsDetailResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/goods/${req.goodsId}`,
    });
  }
}
